<template>
  <div class="vi-phone-number">
    <vi-country-code-picker :value="countryCode" :countries="countries" @input="onInput"/>
    <input ref="input" :value="number" type="number" @input="onInputPhoneNumber" @blur="onBlur"/>
    <div class="bg-input"></div>
  </div>
</template>

<script>
  import ViCountryCodePicker from "./ViCountryCodePicker";
  import {countries} from 'countries-list';

  export default {
    name: 'ViPhoneNumber',
    components: {ViCountryCodePicker},

    props: {
      autofocus: {
        type: Boolean,
        default: false
      },
      number: {},
      prefix: {}
    },

    data: () => {
      let supportedCountryCodes = [
        "CH",
        "AT",
        "DE",
        "FR",
        "RS",
        "MK",
        "BA",
        "SI",
        "HR",
        "IT",
        "ME",
      ];
      return {
        countries: Object.keys(countries)
          .filter(key => supportedCountryCodes.includes(key))
          .reduce((acc, key) => ({...acc, [key]: countries[key]}), {}),
        phoneNumber: null,
      }
    },

    computed: {
      countryCode() {
        if (this.prefix) {
          return Object
            .keys(this.countries)
            .find(key => this.countries[key].phone === this.prefix);
        }
        return 'CH'
      }

    },

    methods: {

      onInputPhoneNumber(event) {
        this.$emit('input', {prefix: this.countries[this.countryCode].phone, number: event.target.value})
      },
      onInput(countryCode) {
        this.$emit('input', {prefix: this.countries[countryCode].phone, number: this.phoneNumber})
      },
      onBlur(event) {
        this.$emit('blur', event)
      }
    },

    mounted() {
      if (this.autofocus) {
        try {
          this.$refs.input.focus()
        } catch (e) {

        }
      }
    }

  }
</script>

<style lang="scss">
  .vi-phone-number {
    position: relative;
    display: flex;
    z-index: 1;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    max-width: 100%;
    box-shadow: none;
    outline: none;
    padding: 0 15px;

    input:focus + .bg-input {
      box-shadow: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }

    input {
      background: none;
      border: none;
      flex: 1;
      font-size: 14px;
      outline: none;
      height: 38px;
    }

    .bg-input {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      /*border-radius: 10px;*/
      border: none;
      padding: 6px 10px;
      /*text-align: center;*/
      font-size: 16px;
      outline: none;
      //  background: #ffffff;
    }
  }
</style>
